/**
 * The code path that triggered a session check. Sent as the
 * x-tsg-session-check-trigger header for tracing 401s in logs.
 */
export enum SessionCheckTrigger {
  FETCH_CURRENT_USER = 'fetch-current-user',
  LOAD_APPLICANT = 'load-applicant',
  ROUTE_LOADER = 'route-loader',
  SESSION_GUARD = 'session-guard',
  SIGN_OUT_PAGE = 'sign-out-page',
}
